import { asterix } from './asterix'
import { demo } from './demo'

import type { BrandProfile } from './BrandProfile'

export type { BrandHeadlineLine, BrandProfile } from './BrandProfile'

/**
 * Реєстр профілів бренду (ADR 048). Ключ — значення `VITE_BRAND`.
 *
 * Прибрати профіль = видалити його файл, його каталог у `public/brands/` і
 * рядок тут.
 */
export const BRAND_PROFILES: Readonly<Record<string, BrandProfile>> = {
    asterix,
    demo,
    // Колишній ключ разового профілю (до 2026-10-29): стенди з `VITE_BRAND=xtransport`
    // отримують Demo, а не Астерікс за замовчуванням
    xtransport: demo,
}

/** Профіль за замовчуванням — Астерікс. */
export const DEFAULT_BRAND = 'asterix'

/**
 * Профіль за значенням `VITE_BRAND`. Порожнє чи невідоме значення дає
 * Астерікс: помилка в змінній не має лишити стенд без бренду.
 */
export const resolveBrandProfile = (id: string | undefined): BrandProfile =>
    BRAND_PROFILES[(id ?? '').trim().toLowerCase()] ?? asterix
